import styled from "styled-components";
export const FormFieldsetContainer = styled.fieldset.withConfig({
  displayName: "formstyles__FormFieldsetContainer",
  componentId: "sc-146ke1n-0"
})(["", ""], {
  display: "flex",
  flexDirection: "column",
  borderWidth: "0px",
  borderColor: "rgba(0, 0, 0, 0)"
});
export const FormContentContainer = styled.div.withConfig({
  displayName: "formstyles__FormContentContainer",
  componentId: "sc-146ke1n-1"
})(["", ""], {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginBottom: "1rem"
});
export const FormActionsContainer = styled.div.withConfig({
  displayName: "formstyles__FormActionsContainer",
  componentId: "sc-146ke1n-2"
})(["", " > *{", " &:first-child{", "}}"], {
  display: "flex",
  justifyContent: "center",
  paddingLeft: "1rem",
  paddingRight: "1rem",
  paddingTop: "2rem",
  paddingBottom: "2rem",
  width: "100%"
}, {
  marginLeft: "1rem"
}, {
  marginLeft: "0px"
});
